// 流量场景属性与运营商联动规则
// 移动/联通/电信/广电/融合：具备基础场景属性；仅融合具备切网模式；
// 国际不具备月用量可超300M、跨省不锁卡、敏感地区使用、切网模式

export const TRAFFIC_SCENE_NETWORK_SWITCH_MODE_OPTIONS = [
  { label: 'AT指令切', value: 'at_command' },
  { label: '断网切', value: 'disconnect' }
]

const DOMESTIC_CARRIER_ATTRS = [
  'exceed_small_traffic_limit',
  'device_sim_unbind',
  'cross_province_no_lock',
  'sensitive_area_usage',
  'personal_real_name'
]

const ATTRS_BY_CARRIER = {
  china_mobile: DOMESTIC_CARRIER_ATTRS,
  china_unicom: DOMESTIC_CARRIER_ATTRS,
  china_telecom: DOMESTIC_CARRIER_ATTRS,
  china_broadnet: DOMESTIC_CARRIER_ATTRS,
  mix_carrier: [...DOMESTIC_CARRIER_ATTRS, 'network_switch_mode'],
  international_carrier: ['device_sim_unbind', 'personal_real_name']
}

export function isTrafficSceneAttrVisible(carrierType, attr) {
  if (!carrierType) {
    return false
  }
  const attrs = ATTRS_BY_CARRIER[carrierType] || []
  return attrs.indexOf(attr) !== -1
}

const ALL_ATTRS = [
  'exceed_small_traffic_limit',
  'device_sim_unbind',
  'cross_province_no_lock',
  'sensitive_area_usage',
  'personal_real_name',
  'network_switch_mode'
]

// 切换运营商时清理不可见属性，避免提交脏数据
export function clearHiddenTrafficSceneAttrs(form, carrierType) {
  const patch = {}
  ALL_ATTRS.forEach((attr) => {
    if (!isTrafficSceneAttrVisible(carrierType, attr)) {
      patch[attr] = undefined
    }
  })
  form.setFieldsValue(patch)
}

// 提交前仅保留当前运营商可配置属性
export function pickVisibleTrafficSceneAttrs(values) {
  const payload = Object.assign({}, values)
  ALL_ATTRS.forEach((attr) => {
    if (!isTrafficSceneAttrVisible(payload.carrier_type, attr)) {
      delete payload[attr]
    }
  })
  return payload
}
